<template>
  <div class="grid">
    <b-row v-for="(row, index) in rows" :key="index" class="row">
      <b-col v-for="(cell, index) in row" :key="index" class="p-0">
        <div class="cell-label">
          <span>{{ cell.label }}</span>
        </div>
        <div class="cell-value">
          <span>{{ cell.value }}</span>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "InfoTable",
  props: {
    rows: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.grid {
  margin-bottom: 15px;
  border: 1px solid #a9acac;
  font-size: clamp(10px, 2.6vw, 12px);
}
.row {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
  text-align: center;
  margin: auto;
}

.cell-label {
  color: #f49c1a;
  background: #e6e7e9;
}

.cell-value {
  color: #231f20;
}

.cell-label,
.cell-value {
  padding: 2px;
}
</style>
